import { render, staticRenderFns } from "./yqjxForm.vue?vue&type=template&id=656ddf83&scoped=true&"
import script from "./yqjxForm.vue?vue&type=script&lang=js&"
export * from "./yqjxForm.vue?vue&type=script&lang=js&"
import style0 from "./yqjxForm.vue?vue&type=style&index=0&id=656ddf83&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656ddf83",
  null
  
)

export default component.exports